import { Backdrop, Box } from "@mui/material";

const GetLoaderName = () => {
  let loaderName = "Loading...";
  try {
    if (typeof window === "undefined" || !window.location) {
      loaderName = "Loading...";
    }
    const hostname = window.location.hostname?.toLowerCase() || "";
    const splited = hostname.split(".")

    if (hostname.includes("idenpro") || splited.includes("idenpro")) {
      loaderName = "IDENPRO";
    } else {
      loaderName = "SIVA";
    }
  } catch (ex) { }
  return loaderName;
}


const LoadingPage = (props) => {

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: 1500 }}
        open={
          props.open === true
            ? props.open
            : props.open === false
              ? props.open
              : true
        }
        onClick={props.onClose}
      >
        {/* <CircularProgress /> */}

        {/* <Box sx={{ display: "flex", flexDirection: "column" }}>
          <div className="loader-Box">
            <span className="loader"></span>
          </div>
          <Box
            className="thankyou"
            style={{
              marginTop: "20px",
              fontSize: "15px",
              letterSpacing: "5px",
            }}
          >
            <span style={{ "--i": 1 }}>L</span>
            <span style={{ "--i": 2 }}>o</span>
            <span style={{ "--i": 3 }}>a</span>
            <span style={{ "--i": 4 }}>d</span>
            <span style={{ "--i": 5 }}>i</span>
            <span style={{ "--i": 6 }}>n</span>
            <span style={{ "--i": 7 }}>g</span>
            <span style={{ "--i": 8 }}>.</span>
            <span style={{ "--i": 9 }}>.</span>
            <span style={{ "--i": 10 }}>.</span>
          </Box>
        </Box> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100vw",
            "& .text-line text": {
              stroke: "#fff",
              strokeWidth: '1px',
              strokeDasharray: 500,
              strokeDashoffset: 500,
              animation: "dash 2s linear forwards infinite, filling 1s ease-in forwards",
              fontStyle: "normal",
              fill: "url(#text-gradient)",
              fontSize: 'calc(4rem + 1vw)',
              // fontWeight: 'bold',
              // fontFamily: "LucidaGrande",
              zIndex: (theme) => theme.zIndex + 1,
            },
            "@keyframes dash": {
              to: {
                strokeDashoffset: 0,
              },
            },
            "@keyframes filling": {
              from: {
                fillOpacity: 0,
              },
              to: {
                fillOpacity: 1,
              },
            },
          }}
        >
          <svg height="200" width="500" className="text-line" style={{ minWidth: '300px' }}  >
            <defs>
              <linearGradient id="text-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style={{ stopColor: "rgb(0, 90, 171)", stopOpacity: 1 }} />
                {/* <stop offset="70%" style={{ stopColor: "rgba(97,238,165,1)", stopOpacity: 1 }} /> */}
                <stop offset="100%" style={{ stopColor: "rgb(57, 181, 74)", stopOpacity: 1 }} />
              </linearGradient>
            </defs>
            <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" className="loader-text">
              {/* SIVA */}
              {GetLoaderName()}
            </text>
          </svg>
        </Box>
      </Backdrop>
    </>
  );
};
export default LoadingPage;
